import type { FC } from 'react';

import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import { InfoIcon } from '@setup/svg-icons/svg-icons';
import { MuiTooltip } from '@shared/ui-kit';

import type { SmallContainerProps } from '@shared/ui/containers/RowWithTitleContainer/components/SmallContainer/types';

const SmallContainer: FC<SmallContainerProps> = ({
  children,
  title,
  titlePadding = 0,
  titleWidth,
  titleVariant,
  titleColor,
  alignItems = 'center',
  isFlexWidth,
  isRequired,
  hideTitleOnMobileSmallContainer,
  infoIconTooltipText,
  hideRowTitle,
  customDisplayVariant,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const variant = titleVariant ? titleVariant : isMobile ? 't12r' : 't12m';
  return (
    <Box display="flex" alignItems={alignItems} width="100%">
      {hideRowTitle || (hideTitleOnMobileSmallContainer && isMobile) ? (
        <></>
      ) : (
        <Typography
          sx={{
            width: titleWidth || { xs: infoIconTooltipText ? '86px' : '56px', sm: '112px' },
            flexShrink: '0',
            paddingTop: `${titlePadding}px`,
            display: customDisplayVariant ? customDisplayVariant : 'flex',
            svg: {
              height: '16px',
              width: '16px',
              path: {
                fill: theme.palette.case.neutral.n500,
              },
            },
          }}
          color={titleColor || theme.palette.case.neutral.n600}
          variant={variant}
        >
          {title}
          {isRequired && (
            <Box component="span" sx={{ color: theme.palette.case.red.r600 }}>
              {' *'}
            </Box>
          )}
          {infoIconTooltipText && (
            <MuiTooltip color="dark" title={infoIconTooltipText}>
              <Box
                sx={{
                  marginLeft: { xs: '4px', sm: '6px' },
                }}
              >
                <InfoIcon />
              </Box>
            </MuiTooltip>
          )}
        </Typography>
      )}

      <Box
        sx={{
          width: isFlexWidth
            ? titleWidth
              ? `calc(100% - ${titleWidth})`
              : { xs: 'calc(100% - 56px)', sm: 'calc(100% - 112px)' }
            : '100%',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default SmallContainer;
